import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Seo from '../components/Seo.js';

const Accessibility = () => {
  const { t } = useTranslation();

  return (
    <main className="container mx-auto px-4 py-8">
      <Seo path="/accessibility" title={t('accessibility.seo.title')} description={t('accessibility.seo.description')} />
      <article>
        <h1 className="text-3xl font-bold mb-4">{t('accessibility.title')}</h1>
        <p className="mb-4">
          {t('accessibility.intro')}
        </p>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('accessibility.measures.title')}</h2>
          <p className="mb-4">
            {t('accessibility.measures.description')}
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>{t('accessibility.measures.item1')}</li>
            <li>{t('accessibility.measures.item2')}</li>
            <li>{t('accessibility.measures.item3')}</li>
            <li>{t('accessibility.measures.item4')}</li>
          </ul>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('accessibility.conformance.title')}</h2>
          <p className="mb-4">
            <Trans i18nKey="accessibility.conformance.description" />
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('accessibility.feedback.title')}</h2>
          <p className="mb-4">
            {t('accessibility.feedback.description')}
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>{t('accessibility.feedback.email')}</li>
          </ul>
        </section>
        <p>
          {t('accessibility.lastUpdated')}
        </p>
      </article>
    </main>
  );
};

export default Accessibility;
